import { Component, OnInit } from '@angular/core';
import { environment as configs } from 'src/environments/environment';
import {HttpClient,HttpParams,HttpEventType,HttpResponse,HttpRequest,HttpHeaders} from '@angular/common/http';
import { NzMessageService ,NzModalService} from 'ng-zorro-antd';
import {ActivatedRoute,Router} from '@angular/router';
import { CommonService } from "../../common.service"
import { Location } from '@angular/common';
import * as $ from 'jquery';
declare var Swal ;
@Component({
  selector: 'app-makepayment',
  templateUrl: './makepayment.component.html',
  styleUrls: ['./makepayment.component.css']
})
export class MakepaymentComponent implements OnInit {

  constructor(private location: Location,private httpClient:HttpClient,private router:Router, private modalService:NzModalService,private CSF: CommonService,private aroute: ActivatedRoute) {
      // console.log(this.CSF.isUserLoggedIn(),"is logged in");
    if(this.CSF.isUserLoggedIn()){
           this.CSF.setNavs(true);
    }else{
         this.CSF.setNavs(false);
    }
  }
   offlinePay:any=0;
   paymethod:any=1;
   host=configs['ApiHost'];
   challanNo:any;
   uploading:any=false
   percentUpload:any=0
   ChallanId:any='';
   WrkName:any;
   WrkYr:any;
   WrkMob:any;
   WrkSerialCode:any
   fee:any;
   feeReceipt:any;
   challanValid:any;
   filetypes:any=['jpg','png','pdf'];
   payAction='https://pgi.billdesk.com/pgidsk/PGIMerchantPayment';
   //payAction="http://localhost:3000/testPayment"
   //payAction="http://bocw.punjab.gov.in/bocwapi/testPayment"
   isEnablePayment=false;
   payMsg:any;
   busy:any=false;
   paymentType:any
   form27='';
   userRole;
  ngOnInit() {
    this.userRole = (localStorage.user)?JSON.parse(localStorage.getItem('user')).role.toString():undefined;
    this.aroute.params.subscribe((i) => {
      // console.log(i, 'params......')
      if(i.challanNo && i.challanNo!==""){
        this.challanNo=i.challanNo
        this.makepaymentonline();
      }
      //this.params = i;
    })

   // 211919229
   //

  }


  makepaymentonline(){
    this.paymethod=0;
    this.offlinePay=2;
    if(this.challanNo!==undefined && this.challanNo!==''){
      this.verifyChallan();
    }
  }

   makepaymentoffline(){
    this.paymethod=0;
    this.offlinePay=1;
    if(this.challanNo!==undefined && this.challanNo!==''){
      this.verifyChallan();
    }
    //this.paychannel =chennelDetail['data'];
  }

  backButton=(step)=>{

       this.paymethod=1;

  }


  async verifyChallan(){
    if(this.challanNo==undefined || this.challanNo.length==0)
      return false;
    var challanInfo= await this.httpClient.post(this.host+'/verify/challan',{challanNo:this.challanNo},{headers:new HttpHeaders({'Access-Control-Allow-Credentials':'true'}), withCredentials:true}).toPromise();
    var challanDetail=challanInfo['data'];
     if(challanDetail && challanDetail.length>0){
      this.ChallanId=challanDetail[0]['ChallanId']
      this.WrkName=challanDetail[0]['WorkerName']
      this.WrkYr=challanDetail[0]['Years']
      this.WrkMob=challanDetail[0]['MobileNo']
      this.fee=challanDetail[0]['Amount']
      this.WrkSerialCode=challanDetail[0]['WorkerSerialNo']
      this.challanValid=1;
      this.paymentType=challanDetail[0]['TypeOfPayment']
      this.isEnablePayment=true
     }else{
       this.challanValid=0;
     }
  }

 public async submitPaymentEntry(frm){
    let type=(this.paymentType==1)?'newreg':'renewal';
    var result= await this.httpClient.post(this.host+'/payment/makePaymentEntry',{challanNo:this.ChallanId,type:type,form27:this.form27},{headers:new HttpHeaders({'Access-Control-Allow-Credentials':'true'}), withCredentials:true}).toPromise();

    // console.log(result);
    if(result['status']==true){

      this.payMsg=result['paymentMsg']
      //console.log(frm.toString())
      frm.querySelector('#msg').value=this.payMsg;
     // console.log(frm.querySelector('#msg').value)
      frm.submit();
    }
    else{
     // alert("something is wrong");
    }
 }

  public uploadFile(fileToUpload: File) {
    const _formData = new FormData();
    _formData.append('file', fileToUpload, fileToUpload.name);
    const reqs = new HttpRequest('POST', this.host+'/upload/image', _formData, {
      reportProgress: true,
    });
    // console.log(reqs)
    return <any>this.httpClient.request(reqs);
  }





  public fileEvent($event,filetypes,fileModal) {
    // console.log($event.target.files[0])
  const fileSelected: File = $event.target.files[0];
  let temparr=fileSelected.name.split('.');
  let extfile=temparr[temparr.length-1]

    if(filetypes.indexOf(extfile)>-1){

      ////////////////////////// upload file ///////////////////////////
    this.uploading=true;
    var prog= this.uploadFile(fileSelected)
      .subscribe( (response) => {
      let event= response
        if (event.type === HttpEventType.UploadProgress) {
            // This is an upload progress event. Compute and show the % done:
            const percentDone = Math.round(100 * event.loaded / event.total);
            this.percentUpload=percentDone;
          } else if (event instanceof HttpResponse) {
            // console.log('file',response.body.filename)
            if(fileModal=='feerecipt'){
                this.feeReceipt=response.body.filename;
            }else{
               this.form27=response.body.filename;

            }
            // console.log(this.form27,this.feeReceipt)
            this.uploading=false;
            this.percentUpload=0;
          }
      })
      /////////////////////////////////////////////////////////////////

      /////////////////////////////////////////////////////////////////

      this.httpClient.request('GET',prog).subscribe(event => {
        // Via this API, you get access to the raw event stream.
        // Look for upload progress events.
        // if (event.type === HttpEventType.UploadProgress) {
        //   // This is an upload progress event. Compute and show the % done:
        //   const percentDone = Math.round(100 * event.loaded / event.total);
          // console.log(`File is ${percentDone}% uploaded.`);
        // } else if (event instanceof HttpResponse) {
        //   console.log('File is completely uploaded!');
        // }
      });

      /////////////////////////////////////////////////////////////////


    }else{

    /*  this.modalService.error({
        title: 'file type not valid. Should be one of following.',
        content: 'Only '+filetypes.join()+' file types are allowed',
        okText:'ok'
      });*/
      Swal.fire({
                type: 'error',
                title: 'file type not valid. Should be one of following.',
                text: 'Only '+filetypes.join()+' file types are allowed'

              })
    }

}

async SubmitFeeDetails(){
  // console.log(this.ChallanId,this.WrkSerialCode,this.feeReceipt)
  if(this.ChallanId!=undefined  && this.WrkSerialCode !=undefined && this.feeReceipt!=undefined){

    let type=(this.paymentType==1)?'newreg':'renewal';
    var paymentinfo= await this.httpClient.post(this.host+'/payment/challan ',{ChallanId:this.ChallanId,WrkSerialCode: this.WrkSerialCode ,feeReceipt:this.feeReceipt,type:type,form27:this.form27},{headers:new HttpHeaders({'Access-Control-Allow-Credentials':'true'}), withCredentials:true}).toPromise();
    // console.log(paymentinfo);
    if(paymentinfo['status']==true){
     /* this.modalService.success({
        title: 'Fee Submitted Sucessfully',
        content: 'Your File submited successfuly.',
        okText:'ok'
      });*/


       Swal.fire({
                type: 'success',
                title: 'Fee Submitted Sucessfully',
                text:  'Your File submited successfuly.'

              })
      this.router.navigate(['worker','register']);
    }

  }else{
    /*this.modalService.error({
      title: 'Something is Wrong',
      content: 'Please Upload Fee Receipt',
      okText:'ok'
    });*/

           Swal.fire({
                type: 'error',
                title: 'Something is Wrong',
                text:  'Please Upload Fee Receipt.'
              })
  }


}

paycscfee(){
  $('#vlechallanid').val(this.challanNo);
  $('#vlepay').submit();
}

goBack() {
  // window.history.back();
  this.location.back();

  console.log( 'goBack()...' );
}

}
